module.exports = __webpack_public_path__ + "media/images/fallback/figures/default_article_image_0-6503a02227188464665adb9cb425272c.png";